import { HeartPulse, MessageCircle, Cable, BookOpen, type LucideIcon } from 'lucide-react'
import { cn } from '@/lib/utils'

export type Section = 'record' | 'chat' | 'integrations' | 'knowledge'

const TABS: { id: Section; label: string; icon: LucideIcon }[] = [
  { id: 'record', label: 'Home', icon: HeartPulse },
  { id: 'chat', label: 'Coach', icon: MessageCircle },
  { id: 'integrations', label: 'Connect', icon: Cable },
  { id: 'knowledge', label: 'Learn', icon: BookOpen },
]

export function TabBar({ active, onNavigate }: { active: Section; onNavigate: (s: Section) => void }) {
  return (
    <nav
      className="flex shrink-0 items-stretch border-t border-border bg-card/95 backdrop-blur"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
    >
      {TABS.map(({ id, label, icon: Icon }) => {
        const on = active === id
        return (
          <button
            key={id}
            onClick={() => onNavigate(id)}
            className="relative flex flex-1 flex-col items-center justify-center gap-1 py-2.5 transition-colors"
          >
            <Icon
              className={cn('size-[22px] transition-colors', on ? 'text-primary' : 'text-muted-foreground')}
              strokeWidth={on ? 2.4 : 2}
            />
            <span className={cn('text-[10px] font-medium transition-colors', on ? 'text-primary' : 'text-muted-foreground')}>
              {label}
            </span>
          </button>
        )
      })}
    </nav>
  )
}
